// Pure countdown helpers for the device-join approval banner. Kept dependency-
// free (no DOM/config imports) so they are unit-testable under plain Node.
import type { PendingJoin } from '../api/types.js';

// formatCountdown renders remaining seconds as a compact "12s" label, clamped
// at 0.
export function formatCountdown(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  return `${s}s`;
}

// secondsRemaining derives a live countdown from the request's expiry so the
// ticker stays accurate between polls. Falls back to the server-sent
// seconds_remaining when expires_at is unparseable.
export function secondsRemaining(req: PendingJoin, now: number = Date.now()): number {
  const exp = new Date(req.expires_at).getTime();
  if (Number.isNaN(exp)) return Math.max(0, req.seconds_remaining || 0);
  return Math.max(0, Math.round((exp - now) / 1000));
}

// diffJoinIds reports whether the SET of pending-join ids changed between polls
// (an id added or removed). Pure + side-effect free so it's unit-testable
// without the api client. A plain poll that only refreshes existing requests
// returns false, so the banner must NOT rebuild its DOM — that rebuild was
// stealing focus from the "Type OK" confirmation input while the user typed.
export function diffJoinIds(prev: Iterable<string>, next: Iterable<string>): boolean {
  const p = new Set(prev);
  const n = new Set(next);
  if (p.size !== n.size) return true;
  for (const id of n) if (!p.has(id)) return true;
  return false;
}
